<template>
    <div class="home-container pb-5">
        <main class="new-survey-questions-container extra-black-color d-flex flex-column align-items-stretch gap-5 p-5">
            <h1 class="after-extra-large-text">ახალი გამოკითხვის შექმნა</h1>
            <section class="d-flex flex-column extra-large-text font-family-400 gap-3">
                <input type="text" class="blue-part-input without-width-limit before-extra-large-text font-family-400" v-model="formVmodelsObj.formTitle" placeholder="გამოკითხვის სათაური">
                <textarea type="text" class="blue-part-input without-width-limit before-extra-large-text font-family-400" rows="6" v-model="formVmodelsObj.formDescription" placeholder="გამოკითხვის აღწერა"></textarea>
            </section>
            <section v-for="(questionObj, i) of formVmodelsObj.questions" class="question-block p-4 d-flex flex-column align-items-stretch border-radius-20 gap-4">
                <h2 class="after-extra-large-text">{{ `კითხვა ${i + 1}` }}</h2>
                <div class="d-flex flex-column align-items-start gap-3">
                    <h2 class="extra-large-text">აირჩიეთ კითხვის ტიპი</h2>
                    <ul class="large-text w-100 d-flex flex-wrap gap-3">
                        <li v-for="(questionTypeObj, i) of questionTypes" @click="questionTypeClickHandler(questionObj, {...questionTypeObj})" :class="['blue-part-input', 'common-transition', {'green': questionObj.chooosenQuestionType == questionTypeObj.questionType}, 'fit-content', 'cursor-pointer']">
                            {{ questionTypeObj.questionType }}
                        </li>
                    </ul>
                </div>
                <input type="text" class="blue-part-input black without-width-limit before-extra-large-text" v-model="questionObj.mainQuestionVmodel" placeholder="ჩაწერეთ კითხვა">
                <div v-if="questionObj.shortAnswer" class="d-flex flex-column align-items-stretch gap-3">
                    <textarea type="text" class="blue-part-input without-width-limit before-extra-large-text font-family-400" disabled  rows="6" placeholder="პასუხის ველი"></textarea> 
                    <!-- v-model="questionObj.shortAnswer.answerVmodel"    do not need vmodel -->
                </div>
                <div class="d-flex flex-column align-items-stretch gap-3" v-else-if="questionObj.Checkbox">
                    <draggable handle=".drag-handle" :list="questionObj.Checkbox.list" :animation="400" @change="log" tag="ul" class="draggable-ul w-100 d-flex flex-column align-items-stretch gap-2">
                       <transition-group>
                           <li class="draggable-li" v-for="(option, i) in questionObj.Checkbox.list" :key="i">
                               <img class="drag-handle" src="@/assets/images/grayMenu.svg" alt="move" style="width: 30px; height: 30px;">
                               <input v-model="option.optionVmodel" style="border-width: 2px;" type="text" class="blue-part-input gray without-width-limit before-extra-large-text font-family-400" placeholder="ჩაწერეთ ტექსტი">
    
                               <img @click="deleteFromArrayOnIndex(questionObj.Checkbox.list, i)" src="@\assets\images\grayDeleteButton.svg" alt="remove" style="width: 30px; height: 30px;" class="ms-1 cursor-pointer">
                           </li>
                       </transition-group>
                   </draggable>
                   <!-- <button @click="addOptionInCheckBox(questionObj.Checkbox)">daamate elementi</button> -->
                   <secondaryButton @click="addOptionInCheckBox(questionObj.Checkbox)" buttonType="button" :showIcon="false" class="large-text font-weight-600" buttonWidth="max-content" paddingX="7px" paddingY="7px">
                        <template v-slot:content>
                            ვარიანტის დამატება
                        </template>
                    </secondaryButton>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-2">
                    <img v-if="i>0 || formVmodelsObj.questions.length > 1" src="@\assets\images\tableDeleteButton.svg" @click="deleteFromArrayOnIndex(this.formVmodelsObj.questions, i)" alt="delete" class="cursor-pointer">
                    <div v-else></div>
                    <div v-if="questionObj.chooosenQuestionType" class="d-flex align-items-center justify-content-end gap-2" >
                        <p class="large-text">სავალდებულო კითხვა</p>
                        <input type="checkbox" v-model="questionObj.checkAsRequired">
                    </div>
                </div>
            </section>
            <section class="d-flex align-items-center justify-content-center gap-3">
                <secondaryButton :mode="1" :showIcon="false" buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px">
                    <template v-slot:content>
                        დასრულება
                    </template>
                </secondaryButton>
                <secondaryButton buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px" @click="addNewQuestion()">
                    <template v-slot:content>
                        შემდეგი კითხვა
                    </template>
                </secondaryButton>
            </section>
        </main>
        <!-- <draggable class="dragArea list-group w-full" v-model="list" @change="log">
            <transition-group>
                <div
                    class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center"
                    v-for="element in list"
                    :key="element.name"
                >
                    {{ element.name }}
                </div>
            </transition-group>
        </draggable> -->
        <!-- handle,  -->
         <!-- .my-handle {
	cursor: move;
	cursor: -webkit-grabbing;
} -->

<!-- ghostClass: "sortable-ghost",  // Class name for the drop placeholder
	chosenClass: "sortable-chosen",  // Class name for the chosen item
	dragClass: "sortable-drag", -->
        <!-- <draggable :list="list" :animation="500" @change="log" tag="ul" class="draggable-ul w-100 d-flex flex-column align-items-stretch gap-3">
            <transition-group>
                <li class="draggable-li" v-for="element in list" :key="element.id">
                    <img src="@/assets/images/grayMenu.svg" alt="move" style="width: 30px; height: 30px;">
                     <div style="height: 30px; width: 30px; background-color: red;">
                     </div>
                     <div style="height: 30px; width: 30px; background-color: red;">
                     </div>
                </li>
            </transition-group>
        </draggable> -->
    </div>
</template>
<script>
import secondaryButton from '@/components/secondaryButton.vue';
import { VueDraggableNext  } from 'vue-draggable-next';
export default {
    data(){
        return {
            questionTypes: [
                {
                    questionType: 'Linear Scale',
                    questionTypeIndicator: 'linearScale',
                    questionTypePreset: {
                        answerVmodel: null,
                    },
                },
                {
                    questionType: 'Checkbox',
                    questionTypeIndicator: 'Checkbox',
                    questionTypePreset: {
                        list: [],
                    },
                },
                {
                    questionType: 'Multiple Choice',
                    questionTypeIndicator: 'multipleChoice',
                    questionTypePreset: {
                        answerVmodel: null,
                    },
                },
                {
                    questionType: 'Relocate',
                    questionTypeIndicator: 'Relocate',
                    questionTypePreset: {
                        answerVmodel: null,
                    },
                },
                {
                    questionType: 'DropDown',
                    questionTypeIndicator: 'DropDown',
                    questionTypePreset: {
                        answerVmodel: null,
                    },
                },
                {
                    questionType: 'Short Answer',
                    questionTypeIndicator: 'shortAnswer',
                    questionTypePreset: {
                        // answerVmodel: null,
                    },
                },
                {
                    questionType: 'Long Answer',
                    questionTypeIndicator: 'longAnswer',
                    questionTypePreset: {
                        answerVmodel: null,
                    },
                },
            ],
            formVmodelsObj: {
                formTitle: null,
                formDescription: null,
                questions: [
                    {
                        chooosenQuestionType: null,
                        mainQuestionVmodel: null,
                        checkAsRequired: false,
                    },
                ],
            },
            // list: [
            //     { name: 'John', id: 1 },
            //     { name: 'luka', id: 2 },
            //     { name: 'nika', id: 3 },
            //     { name: 'nini', id: 4 },
            // ],
        }
    },
    components: {
        secondaryButton,
        draggable: VueDraggableNext,
    },
    methods: {
        questionTypeClickHandler(questionObj, questionTypeObj){
            this.questionTypes.forEach((questionType) => {
                if(questionObj[questionType.questionTypeIndicator]){
                    delete questionObj[questionType.questionTypeIndicator];
                }
            });
            questionObj.mainQuestionVmodel = null;
            questionObj.checkAsRequired = false;
            questionObj.chooosenQuestionType = questionTypeObj.questionType;
            questionObj[questionTypeObj.questionTypeIndicator] = JSON.parse(JSON.stringify(questionTypeObj.questionTypePreset));;
    
        },
        addNewQuestion(){
            this.formVmodelsObj.questions.push(
                {
                    chooosenQuestionType: null,
                    mainQuestionVmodel: null,
                    checkAsRequired: false,
                },
            );
        },
        deleteFromArrayOnIndex(array, index){
            array.splice(index, 1);
        },
        deleteQuestion(index){
            this.formVmodelsObj.questions.splice(index, 1);
        },
        log(event) {
            // console.log(event)
            // console.log(this.list);
            
        },
        addOptionInCheckBox(checkbox){
            checkbox.list.push({ optionVmodel: null });
        },
    }
}
</script>
<style scoped lang="scss">
.home-container{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(1, min-content);
    row-gap: 2em;
    place-items: center;
}
.new-survey-questions-container{
    background-color: var(--secondary-background-color);
    width: 70%;
    border-radius: 40px;
}
.blue-part-input.without-width-limit{
    max-width: none;
}
.blue-part-input.fit-content{
    width: fit-content;
}
.question-block{
    border: 1px solid var(--light-blue);
}
.draggable-li{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .5em;
    border-radius: 10px;
    .drag-handle{
        cursor: move;
	    cursor: -webkit-grabbing;
    }
}
@media (max-width: 1800px) {
    .new-survey-questions-container{
        width: 80%;
    }
}
@media (max-width: 1200px) {
    .new-survey-questions-container{
        width: 100%;
    }
}
</style>